<template>
  <div>
    <b-overlay :show="loadParticipants" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
      <!-- Close Button (top-right) -->
      <div v-if="
        selectedSurveyType == 'hod_feedback' ||
        selectedSurveyType == 'class_advisors_feedback' ||
        selectedSurveyType == 'infrastructure_feedback'
      " class="text-right mb-2">
        <b-button variant="danger" size="sm" class="text-white font-weight-bold border-0 px-3 py-1 no-print"
          @click="$emit('close-report')">
          X
        </b-button>
      </div>


      <div class="printReport mb-2 text-right no-print">
        <b-button variant="danger" size="sm" @click="downloadParticipant()">
          Download
        </b-button>
      </div>

      <div class="participantReport p-4">
        <div class="selectGroup mb-2 d-flex justify-content-between no-print">
          <b-form-select v-if="selectedSurveyType == 'student_feedback' ||
            selectedSurveyType == 'hod_feedback' ||
            selectedSurveyType == 'class_advisors_feedback' ||
            selectedSurveyType == 'infrastructure_feedback'
          " :options="groupsWithSubgroupsOptions" v-model="selectedGroupSubgroup" @change="getParticipants"
            class="w-50"></b-form-select>
        </div>

        <br />

        <div id="printParticipantReport">
          <div class="instituteDetails mb-3 text-center">
            <h5 style="font-size: 24px; font-weight: 600">
              {{ selectedInstitute.name }}
            </h5>
            <h6 v-if="selectedInstitute.name_2 != null" style="font-size: 20px; font-weight: 600">
              {{ selectedInstitute.name_2 }}
            </h6>
            <h6 v-if="selectedInstitute.name_3 != null" style="font-size: 20px; font-weight: 600">
              {{ selectedInstitute.name_3 }}
            </h6>
          </div>

          <br />

          <!-- <h5 style="font-size: 20px; font-weight: 600">
            ~ Participation Report
            <span v-if="selectedGroupSubgroup != null">
              For:
              <span class="text-info">{{ selectedGroupSubgroup.name }}</span>
            </span>
          </h5> -->

          <table class="table table-striped table-bordered">
            <thead class="thead-dark">
              <tr>
                <th v-if="rollNumberAvailable" class="align-middle">
                  Roll Number
                </th>
                <th class="w-50 align-middle">Name</th>
                <th class="w-25 align-middle">Start</th>
                <th class="w-25 align-middle">End</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="participants.length == 0">
                <td colspan="100" class="align-middle text-center text-danger">
                  No Data Found!
                </td>
              </tr>
              <tr v-for="(student, studentIndex) in participants" :key="studentIndex" v-else>
                <td v-if="rollNumberAvailable" class="text-center align-middle">
                  {{ student.roll_number }}
                </td>
                <td class="text-center align-middle">
                  {{ student.first_name || '' }} {{ student.last_name || '' }}
                </td>
                <td class="align-middle">{{ student.pivot.starts_at }}</td>
                <td class="align-middle">
                  {{ formatDateIST(student.pivot.end_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: [
    "subgroupId",
    "selectedSurveyType",
    "groupsWithSubgroupsOptions",
    "survey_id",
    "getCustomNames",
  ],

  watch: {
    groupsWithSubgroupsOptions: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 1 && !this.selectedGroupSubgroup) {
          if (this.subgroupId) {
            this.selectedGroupSubgroup = this.subgroupId;
          } else {
            this.selectedGroupSubgroup = newVal[1].value;
          }

          this.getParticipants();   // FIRST CALL
          return;                   // STOP HERE → prevents second call
        }

        if (this.selectedSurveyType === "course_exit" || this.selectedSurveyType === "programme_exit") {
          this.getParticipants();   // Will run only once
        }
      }
    }

  },

  data() {
    return {
      participants: [],
      loadParticipants: false,
      selectedInstitute: {},
      rollNumberAvailable: false,
      // loadingPdf: false,
      selectedGroupSubgroup: null
    };
  },
  methods: {
    formatDateIST(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      const istOffset = 5.5 * 60;
      const utc = date.getTime() + date.getTimezoneOffset() * 60000;
      const istTime = new Date(utc + istOffset * 60000);

      const day = istTime.getDate().toString().padStart(2, "0");
      const month = (istTime.getMonth() + 1).toString().padStart(2, "0");
      const year = istTime.getFullYear();

      let hours = istTime.getHours();
      const minutes = istTime.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    },


    getParticipants() {
      this.loadParticipants = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/studfbsurveystudents/report`;
      this.$axios
        .post(url, {
          survey: this.survey_id,
          usersubgroup: this.selectedGroupSubgroup,
        })
        .then((response) => {
          this.participants = response.data;
          this.rollNumberAvailable = true;
          this.loadParticipants = false;
        })
        .catch((error) => {
          this.loadParticipants = false;
          console.error(error);
        });
    },


    clearSubgroupSelection() {
      this.selectedGroupSubgroup = null;
      this.getParticipants();
    },

    async downloadParticipant() {
      this.loadingPdf = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveystudents/report/pdfexport`;
      await this.$axios
        .post(
          url, {
          survey: this.survey_id,
          usersubgroup: this.selectedGroupSubgroup,
        }, { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "participant report.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.downloadData = false;
        })
        .catch(() => {
          this.$toast.error('Failed to download', {
            position: "top",
            duration: 7000,
          });
        });
      this.loadingPdf = false;
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>
